import React from 'react';
import { Line } from 'react-chartjs-2';

const InstrumentosVelocidad = ({ alarma, currentAlarmaEstatus, getGraficaVelocidad }) => {
  return (
    <div className='row'>
      {/* Odómetro */}
      <div className='col-2 p-2'>
        <svg width="100%" height="100%" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" style={{maxWidth: "200px", maxHeight: "200px"}}>
          <circle cx="100" cy="100" r="90" fill="#f0f0f0" stroke="black" strokeWidth="2" />
          <rect x="95" y="9" width="8" height="10" fill="green" transform="rotate(-90 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="green" transform="rotate(-80 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="green" transform="rotate(-70 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="green" transform="rotate(-60 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="green" transform="rotate(-50 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="green" transform="rotate(-40 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="green" transform="rotate(-30 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="green" transform="rotate(-20 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="blue"  transform="rotate(-10 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="blue"  transform="rotate(  0 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="blue"  transform="rotate( 10 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="blue"  transform="rotate( 20 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="blue"  transform="rotate( 30 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="red"   transform="rotate( 40 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="red"   transform="rotate( 50 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="red"   transform="rotate( 60 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="red"   transform="rotate( 70 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="red"   transform="rotate( 80 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="red"   transform="rotate( 90 100 100)" />

          <text x="25" y="105" textAnchor="middle" fontSize="10">0</text>
          <text x="30" y="80" textAnchor="middle" fontSize="10">20</text>
          <text x="45" y="55" textAnchor="middle" fontSize="10">40</text>
          <text x="65" y="40" textAnchor="middle" fontSize="10">60</text>
          <text x="86" y="33" textAnchor="middle" fontSize="10">80</text>
          <text x="110" y="33" textAnchor="middle" fontSize="10">100</text>
          <text x="135" y="40" textAnchor="middle" fontSize="10">120</text>
          <text x="150" y="55" textAnchor="middle" fontSize="10">140</text>
          <text x="165" y="75" textAnchor="middle" fontSize="10">160</text>
          <text x="170" y="103" textAnchor="middle" fontSize="10">180</text>

          <rect
            x="95"
            y="40"
            width="8"
            height="60"
            fill="red"
            transform={`rotate(${-90+(currentAlarmaEstatus.sateliteSpeed? currentAlarmaEstatus.sateliteSpeed: alarma.velocidad)} 100 100)`}
          />
          <text x="100" y="120" textAnchor="middle" fontSize="20">
              {currentAlarmaEstatus.sateliteSpeed? currentAlarmaEstatus.sateliteSpeed: alarma.velocidad} km/h
          </text>
          <text x="100" y="160" textAnchor="middle" fontSize="15">Velocidad</text>
        </svg>
      </div>

      {/* Brújula */}
      <div className='col-2 p-2'>
        <svg width="100%" height="100%" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" style={{maxWidth: "200px", maxHeight: "200px"}}>
          <circle cx="100" cy="100" r="90" fill="#f0f0f0" stroke="black" strokeWidth="2" />
          <circle cx="100" cy="100" r="5" fill="red" stroke="red" strokeWidth="2" />

          <rect x="95" y="9" width="8" height="10" fill="red"  transform="rotate(  0 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="red"  transform="rotate(  90 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="red"  transform="rotate(  180 100 100)" />
          <rect x="95" y="9" width="8" height="10" fill="red"  transform="rotate(  270 100 100)" />

          <text x="98" y="50" textAnchor="middle" fontSize="30">N</text>
          <text x="165" y="105" textAnchor="middle" fontSize="30">E</text>
          <text x="98" y="170" textAnchor="middle" fontSize="30">S</text>
          <text x="35" y="112" textAnchor="middle" fontSize="30">O</text>

          <rect x="95" y="40" width="8" height="60" fill="red" transform={`rotate(${alarma.direction? alarma.direction: 0} 100 100)`} />
          <text x="100" y="120" textAnchor="middle" fontSize="10">Dirección</text>
        </svg>
      </div>

      {/* Gráfica de velocidad */}
      <div className='col-8'>
        <div className="p-3">
          <Line
            data={getGraficaVelocidad()}
            width={"100%"}
            options={{ maintainAspectRatio: false }}
          />
        </div>
      </div>
    </div>
  );
};

export default InstrumentosVelocidad;
